import * as types from './types';

const INITIAL_STATE = {
  time: null,
  fetching: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.GET_SERVER_TIME_FETCH:
      return {
        ...state,
        time: payload,
      };
    case types.GET_SERVER_TIME_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.GET_SERVER_TIME_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/serverTime/reducer.js